'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const LinkFilesIcon = createIcon({
    displayName: 'LinkFilesIcon',
    viewBox: '0 0 16 16',
    fill: 'none',
    path: (
        <>
            <g clipPath="url(#prefix__clip0_22870_272880)">
                <path
                    d="M9.333 2.313v2.753c0 .374 0 .56.073.703a.667.667 0 00.291.291c.143.073.33.073.703.073h2.753M8 12.8v-4m-2 2h4m-.667-8.667H5.867c-1.12 0-1.68 0-2.108.218a2 2 0 00-.875.874c-.217.428-.217.988-.217 2.108v6.933c0 1.12 0 1.68.217 2.108a2 2 0 00.875.874c.427.218.987.218 2.108.218h4.266c1.12 0 1.68 0 2.108-.218a2 2 0 00.874-.874c.218-.428.218-.988.218-2.108V6.133l-4-4z"
                    stroke="currentColor"
                    strokeWidth={1.2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="prefix__clip0_22870_272880">
                    <path
                        fill="#fff"
                        transform="translate(0 .8)"
                        d="M0 0h16v16H0z"
                    />
                </clipPath>
            </defs>
        </>
    ),
})

export default LinkFilesIcon
